// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselStyles } from "@guestsupply/Overrides/Widgets/Common/ProductCarousel";
import { hideElementOnPrint } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productCarouselStyles.container = {
    css: css`
        margin: 25px 0;
        ${hideElementOnPrint}
    `,
};

productCarouselStyles.productCategoriesSelect = {
    css: css`
        margin-bottom: 12px;
    `,
};

productCarouselStyles.carouselProductWrapper = {
    css: css`
        display: flex;
        justify-content: center;
    `,
};

productCarouselStyles.productMiniCardStyles = {
    productPartNumbersStyles: {
        container: {
            css: css`
                margin-top: 0;
            `,
        },
    },
    productDescription: {
        productDetailLink: {
            css: css`
                margin-bottom: 4px; /* Take in the consideration gap 4px */
            `,
        },
    },
};
